import { useCallback, useEffect, useRef, useState } from "react";
import { fetchAdsForTopics } from "../lib/api";

// Picks a random element different from `excludeId`. Returns `null` when none.
function pickAlt(pool, excludeId) {
  const alts = pool.filter((a) => a?.id !== excludeId);
  if (!alts.length) return null;
  return alts[Math.floor(Math.random() * alts.length)];
}

// Manages the pool of ad campaigns + hero/feed slots. All setters are stable
// and the pool lives in a ref so callbacks stay referentially stable.
export function useAdsData() {
  const poolRef = useRef([]);
  const [heroAd, setHeroAd] = useState(null);
  const [feedAds, setFeedAds] = useState([]);

  useEffect(() => {
    let cancelled = false;
    fetchAdsForTopics()
      .then(({ pool }) => {
        if (cancelled) return;
        poolRef.current = pool;
        setHeroAd(pool[0] || null);
        // Il numero dei post è dinamico: manteniamo il pool reale e
        // ArgumentFeed lo distribuisce ogni cinque messaggi disponibili.
        setFeedAds(pool.length > 1 ? pool.slice(1) : pool);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  const swapHeroAd = useCallback(() => {
    setHeroAd((prev) => pickAlt(poolRef.current, prev?.id) ?? prev);
  }, []);

  const swapFeedAdAt = useCallback((slotIndex) => {
    setFeedAds((prev) => {
      const next = pickAlt(poolRef.current, prev[slotIndex]?.id);
      if (!next) return prev;
      const copy = prev.slice();
      copy[slotIndex] = next;
      return copy;
    });
  }, []);

  return { heroAd, feedAds, swapHeroAd, swapFeedAdAt };
}
